import {
  MeetingTranscript,
  MeetingTranscriptChunk,
  MeetingTranscriptSegment,
} from 'api/meeting/types';

export const findSegmentAtTime = (
  transcript: MeetingTranscriptSegment[],
  time: number,
) => {
  // First, try to find an exact match (segment that contains the time)
  const exactMatch = transcript.find((segment) => {
    const fromTime = parseFloat(segment.start);
    const toTime = parseFloat(segment.end);

    return time >= fromTime && time <= toTime;
  });

  if (exactMatch) {
    return exactMatch;
  }

  // If no exact match, find the nearest segment
  if (transcript.length === 0) {
    return undefined;
  }

  let nearestSegment: MeetingTranscriptSegment | undefined;
  let minDistance = Infinity;

  for (const segment of transcript) {
    const fromTime = parseFloat(segment.start);
    const toTime = parseFloat(segment.end);

    let distance: number;

    if (time < fromTime) {
      // Time is before this segment
      distance = fromTime - time;
    } else if (time > toTime) {
      // Time is after this segment
      distance = time - toTime;
    } else {
      // This shouldn't happen since we already checked for exact match
      // But just in case, distance is 0
      distance = 0;
    }

    if (distance < minDistance) {
      minDistance = distance;
      nearestSegment = segment;
    }
  }

  return nearestSegment;
};

export const findChunkAtTime = (
  chunks: MeetingTranscriptChunk[],
  time: number,
) => {
  return chunks.find((chunk) => {
    const fromTime = parseFloat(chunk.start);
    const toTime = parseFloat(chunk.end);

    return time >= fromTime && time <= toTime;
  });
};
export const scrollToTranscriptSegment = (
  segment: MeetingTranscriptSegment,
) => {
  document
    .querySelector(
      `[data-transcript-segment][data-from-time="${segment.start}"]`,
    )
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
export const findSegmentAndChunkAtTime = (
  transcript: MeetingTranscript,
  time: number,
): {
  segment?: MeetingTranscriptSegment;
  chunk?: MeetingTranscriptChunk;
} => {
  const segment = findSegmentAtTime(transcript.segments, time);

  if (!segment) {
    return { segment: undefined, chunk: undefined };
  }

  const chunk = findChunkAtTime(segment.chunks ?? [], time);

  if (!chunk) {
    return { segment, chunk: undefined };
  }

  return { segment, chunk };
};
